import { Tooltip } from '../ui/tooltip'
import classNames, { ClassValue } from 'classnames'
import React, { ReactNode } from 'react'

export const TooltipHeader = (display: string, title: string, description?: ReactNode) => () => {
    return () => {
        const tooltipContent = (
            <TooltipContent
                title={title}
                description={description}
                descriptionClassName="italic text-xs"
            />
        )
        return (
            <Tooltip content={tooltipContent} openOnTargetFocus={false}>
                {display}
            </Tooltip>
        )
    }
}

export const AcosHeader = TooltipHeader('ACOS', 'Advertising Cost of Sale', 'spend / sales')
export const TosImpShareHeader = TooltipHeader('TOS Imp. Share', 'Top of Search Impression Share')
export const RoasHeader = TooltipHeader('ROAS', 'Return on Ad Spend', 'sales / spend')
export const CtrHeader = TooltipHeader('CTR', 'Click-through Rate', 'clicks / impressions')
export const CpcHeader = TooltipHeader('CPC', 'Cost per Click', 'spend / clicks')
export const CvrHeader = TooltipHeader('CVR', 'Conversion Rate', 'orders / clicks')
export const CacHeader = TooltipHeader('CAC', 'Customer Acquisition Cost', 'spend / orders')
export const AovHeader = TooltipHeader('AOV', 'Average Order Value', 'sales / orders')
export const RpcHeader = TooltipHeader('RPC', 'Revenue per Click', 'sales / clicks')
export const TargetCpcHeader = TooltipHeader('Target CPC', 'Target Cost per Click')
export const AdjustedOrdersHeader = () => {
    let v = TooltipHeader('Adj Orders', 'Adjusted Orders', 'orders * sales impact multiplier')()()
    return <>{v}</>
}

interface TooltipContentProps {
    title: string
    description?: ReactNode
    descriptionClassName?: ClassValue
}

export const TooltipContent = ({
    title,
    description = undefined,
    descriptionClassName,
}: TooltipContentProps) => {
    return (
        <div className="text-center">
            <span>{title}</span>
            <br></br>
            {description && <span className={classNames(descriptionClassName)}>{description}</span>}
        </div>
    )
}
